import { Heart, Sparkles, Shield, Leaf, Palette, Flag } from "lucide-react";

const values = [
  { icon: Heart, label: "Respect", desc: "We treat every child, elder and living being with dignity", color: "from-rose-500 to-pink-600", bg: "bg-rose-50", text: "text-rose-700" },
  { icon: Sparkles, label: "Kindness", desc: "Small acts of caring build big, gentle hearts", color: "from-amber-500 to-orange-600", bg: "bg-amber-50", text: "text-amber-700" },
  { icon: Shield, label: "Integrity", desc: "Truth in speech, honesty in action, purity in thought", color: "from-emerald-500 to-teal-600", bg: "bg-emerald-50", text: "text-emerald-700" },
  { icon: Leaf, label: "Compassion", desc: "Feeling for others and helping without being asked", color: "from-lime-500 to-green-600", bg: "bg-lime-50", text: "text-lime-700" },
  { icon: Palette, label: "Creativity", desc: "Freedom to imagine, make and reinvent every day", color: "from-fuchsia-500 to-purple-600", bg: "bg-fuchsia-50", text: "text-fuchsia-700" },
  { icon: Flag, label: "Patriotism", desc: "Rooted love for Bharat, its culture and its future", color: "from-orange-500 to-red-600", bg: "bg-orange-50", text: "text-orange-700" }
];

const ValuesInfographic = () => (
  <section className="py-16 bg-gradient-to-b from-white via-amber-50/50 to-white" data-testid="values-infographic">
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <span className="inline-block text-[10px] font-bold text-orange-700 tracking-widest uppercase mb-2">Our Six Pillars</span>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-stone-800 mb-3">The Values We Live By</h2>
        <p className="text-stone-600 text-sm md:text-base">Six seeds we plant in every child's heart — so that when they grow, they grow rooted, joyful and worthy.</p>
      </div>

      {/* Central circle + orbiting cards */}
      <div className="relative max-w-5xl mx-auto">
        {/* Central Sanskrit medallion */}
        <div className="hidden lg:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 w-48 h-48 rounded-full bg-gradient-to-br from-orange-950 via-red-950 to-amber-950 items-center justify-center shadow-2xl">
          <div className="text-center px-4">
            <p className="font-devanagari text-3xl text-yellow-100 leading-none mb-1">सत्यम्<br/>शिवम्<br/>सुन्दरम्</p>
            <p className="text-[10px] text-orange-100 mt-2 tracking-wider">TRUTH · GOOD · BEAUTY</p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {values.map((v, i) => {
            const Icon = v.icon;
            return (
              <div
                key={v.label}
                className={`p-5 rounded-2xl ${v.bg} border border-white shadow-md hover:shadow-xl transition-all hover:-translate-y-1 ${
                  i === 1 || i === 4 ? "lg:mt-16" : ""
                }`}
                data-testid={`value-${v.label.toLowerCase()}`}
              >
                <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${v.color} flex items-center justify-center shadow mb-3`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <h3 className={`font-display text-lg font-bold ${v.text} mb-1`}>{v.label}</h3>
                <p className="text-sm text-stone-600 leading-relaxed">{v.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

export default ValuesInfographic;
